var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0573 9.54089C19.8323 3.57339 15.1306 0.886719 11.0006 0.886719C11.0006 0.886719 11.0006 0.886719 10.9889 0.886719C6.8706 0.886719 2.15727 3.56047 0.932266 9.52797C-0.432734 16.193 3.25393 21.8376 6.5906 25.3896C7.82727 26.7071 9.41393 27.3659 11.0006 27.3659C12.5873 27.3659 14.1739 26.7071 15.3989 25.3896C18.7356 21.8376 22.4223 16.2059 21.0573 9.54089ZM11.0006 16.0121C8.9706 16.0121 7.3256 14.1909 7.3256 11.9434C7.3256 9.69589 8.9706 7.87464 11.0006 7.87464C13.0306 7.87464 14.6756 9.69589 14.6756 11.9434C14.6756 14.1909 13.0306 16.0121 11.0006 16.0121Z",
    fill: "#077D65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fd0c704b0cf0f182a806c2f2ea1dcd34.svg";
export { ForwardRef as ReactComponent };